module.exports = {"cash_back":"Combine with<1></1><2>Cash Incentives</2> up to","rates":"Don't forget about<1></1>our <2>rates</2> as low as"}